import { type ListFacet, ListFilters } from "./snowflakes/ListFilters";
import { SearchFilterToolbar } from "./snowflakes/SearchFilterToolbar";

interface SearchAndFiltersProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  onSearch?: (value: string) => void;
  searchPlaceholder?: string;
  filterAriaLabel?: string;
  activeFilterCount?: number;
  canReset?: boolean;
  onReset: () => void;
  facets: ListFacet[];
}

export function SearchAndFilters({
  searchValue,
  onSearchChange,
  onSearch,
  searchPlaceholder = "Search",
  filterAriaLabel = "Filters",
  activeFilterCount = 0,
  canReset,
  onReset,
  facets,
}: SearchAndFiltersProps) {
  return (
    <SearchFilterToolbar
      onSearch={onSearch}
      onSearchChange={onSearchChange}
      searchAriaLabel={searchPlaceholder}
      searchPlaceholder={searchPlaceholder}
      searchValue={searchValue}
    >
      <ListFilters
        activeFilterCount={activeFilterCount}
        ariaLabel={filterAriaLabel}
        canReset={canReset}
        facets={facets}
        onReset={onReset}
      />
    </SearchFilterToolbar>
  );
}
